var _rect, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 36",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "South Korea flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-8a8 8 0 0 1 0 16 4 4 0 0 0 0-8 4 4 0 0 1 0-8z",
    fill: "#cd2e3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 0-16 4 4 0 0 0 0 8 4 4 0 0 1 0 8z",
    fill: "#0047a0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "rotate(-28 12 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 8,
    height: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "rotate(28 42 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 6,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 9,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 8,
    height: 1.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "rotate(28 12 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 24.5,
    width: 4.8,
    height: 1.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "rotate(-28 42 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 24.5,
    width: 4.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 8,
    height: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.2d61505cf7729f7768d747304562271b.svg";
export { ForwardRef as ReactComponent };